// extracted by mini-css-extract-plugin
module.exports = {"HeaderSection":"HeaderSection_HeaderSection__pmSoL","white":"HeaderSection_white__2QIB5","dashStriped":"HeaderSection_dashStriped__2-f1p"};